module.exports = __webpack_public_path__ + "img/Watermelon_Salad.142da069.jpg";